import { Typography } from '@p2p/components';
import { MainContainer, usePaymentData } from '@p2p/entities/payment';
import { MSP_CONFIRM_AMOUNT_SESSION_KEY, MSP_PAGE, ORDER_STATUS } from '@p2p/shared/constants';
import { Navigate, useParams } from 'react-router-dom';

import { InfoBlock, Loading } from './components';
import styles from './CreateRequisitePage.module.scss';

export const CreateRequisitePage = () => {
  const { id = '' } = useParams<{ id: string }>();
  const { order } = usePaymentData();

  if (sessionStorage.getItem(MSP_CONFIRM_AMOUNT_SESSION_KEY) !== id) {
    return <Navigate to={`${MSP_PAGE}/${id}`} replace />;
  }

  if (order.status === ORDER_STATUS.BRAND_NEW) {
    return <Navigate to={`${MSP_PAGE}/${id}/details`} replace />;
  }

  return (
    <MainContainer className={styles.container}>
      <div className={styles.heading}>
        <Typography className={styles.headingTitle} variant="h1" color="heading" component="h1">
          Дождитесь завершения операции
        </Typography>
        <div className={styles.loading}>
          <Loading />
          <Typography variant="h3" color="heading">
            Создаём заявку
            <span className={styles.loadingDots}>
              <span className={styles.loadingDot}>.</span>
              <span className={styles.loadingDot}>.</span>
              <span className={styles.loadingDot}>.</span>
            </span>
          </Typography>
        </div>
      </div>
      <InfoBlock />
    </MainContainer>
  );
};
